import React from 'react';
import {
  BrandBadge,
  ErrorBadge,
  InfoBadge,
  NeutralBadge,
  NeutralInverseBadge,
  SuccessBadge,
  WarningBadge,
} from '../../components/Badge';

export type TImageBadges = {
  opvalStickerText?: string;
  infoText?: string;
  errorText?: string;
  successText?: string;
  warningText?: string;
  neutralText?: string;
  neutralInverse?: string;
};

const imageBadgeMap = {
  opvalStickerText: BrandBadge,
  infoText: InfoBadge,
  errorText: ErrorBadge,
  successText: SuccessBadge,
  warningText: WarningBadge,
  neutralText: NeutralBadge,
  neutralInverse: NeutralInverseBadge,
};

const ImageBadges = ({ badges }: { badges: TImageBadges }) => {
  if (!badges) return null;

  return (
    <div className="hz-badges">
      {Object.entries(badges).map(([key]) => {
        const Badge = imageBadgeMap[key];
        return badges[key] ? <Badge key={key}>{badges[key]}</Badge> : null;
      })}
    </div>
  );
};

export default ImageBadges;
